module.exports = __webpack_public_path__ + "img/1.cf4c1b4d.png";